import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, FieldArray } from 'redux-form';
import RFReactSelect from './RFReactSelect';
import WYSIWYG from '../../../components/forms/redux-form/WYSIWYG';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import AsyncSelect from 'react-select/lib/Async';
import renderTasks from './EventTask';

class EventForm extends React.Component {
  constructor() {
    super();

    this.state = {
      primary: {},
      showEscalation: false,
      testForms: [],
    };
  }

  componentDidMount() {
    //const initialValues = this.props;
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          maxLength={maxLength}
        />
        <span className="small">Only 500 characters allowed</span>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTypesSelect = ({
    meta: { touched, error, warning },
    label,
    ...allProps
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <RFReactSelect
          {...allProps}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect1 = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control">
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderWYSIWYG = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <WYSIWYG input={input} />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          // dateFormat="YYYY-MM-DD"
          timeFormat={true}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY HH:mm')
                : moment().format('MM/DD/YYYY HH:mm');
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
              // input.onChange(param)
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderRepsSelect = ({ meta: { touched, error, warning }, label, input }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={this.searchUsers}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
          placeholder="Type User Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onRepChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onRepChange = val => {
    this.props.change('reps', val);
  };

  renderUsersSelect = ({ meta: { touched, error, warning }, label, input }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.searchUsers}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
          placeholder="Type User Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onUserChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onUserChange = val => {
    this.props.change('assignedTo', val);
  };

  onChange = (e, val) => {
    if (val === 'Y') {
      this.setState({ showEscalation: true });
    } else {
      this.setState({ showEscalation: false });
    }
  };

  searchUsers = search => {
    return this.props.searchUsers(search, 'isActive');
  };

  addTestForm(items) {
    this.setState({
      testForms: [...items],
    });
    this.props.change('event', 'tasks', [...items]);
  }

  render() {
    const {
      meetingtypes,
      escalationtypes,
      handleSubmit,
      initialValues,
      pristine,
      submitting,
    } = this.props;

    const IsClientConcern = initialValues.clientConcerns === 'Y';

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Event</legend>
          <Field
            className="form-control"
            name="meetingDate"
            component={this.renderDateField}
            type="text"
            placeholder="MeetingDate"
            label="Meeting Date"
          />
          {meetingtypes && (
            <Field
              name="meetingTypeId"
              component={this.renderTypesSelect}
              options={meetingtypes}
              label="Meeting Type"
            />
          )}
          <Field name="reps" component={this.renderRepsSelect} label="Rep" />
          <Field
            className="form-control"
            name="plan"
            component={this.renderField}
            type="text"
            placeholder="Plan"
            label="Plan"
            maxLength={500}
          />
          <Field
            className="form-control"
            name="recap"
            component={this.renderField}
            type="text"
            placeholder="Recap"
            label="Recap"
            maxLength={500}
          />
          <Field
            className="form-control"
            name="overallScore"
            component={this.renderSelect1}
            type="text"
            label="Overall Score"
          >
            <option value="-1">Select</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </Field>
          <Field
            className="form-control"
            name="notes"
            component={this.renderWYSIWYG}
            type="text"
            placeholder="Notes"
            label="Notes"
          />
          <Field
            className="form-control"
            name="clientConcerns"
            component={this.renderSelect1}
            type="text"
            label="Serious Client Concerns"
            onChange={this.onChange}
          >
            <option value="-1">Select</option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </Field>
        </fieldset>
        <fieldset>
          <div className="form-group">
            <label className="col-md-2 control-label">Closed</label>
            <div className="col-md-10">
              <div className="checkbox">
                <label>
                  <Field name="isClosed" component="input" type="checkbox" />
                </label>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>Tasks</legend>
          <FieldArray
            name="tasks"
            component={renderTasks}
            props={{ searchUsers: this.searchUsers }}
          />
        </fieldset>
        {this.state.showEscalation && !IsClientConcern && (
          <fieldset>
            <legend>Escalation</legend>
            <Field
              className="form-control"
              name="dateReported"
              component={this.renderDateField}
              type="text"
              placeholder="DateReported"
              label="Date Reported"
            />
            <Field
              className="form-control"
              name="issueName"
              component={this.renderField}
              type="text"
              placeholder="IssueName"
              label="Issue Name"
            />
            <Field
              name="issueTypeId"
              component={this.renderTypesSelect}
              options={escalationtypes}
              label="Issue Type"
            />
            <Field
              className="form-control"
              name="importance"
              component={this.renderSelect1}
              type="text"
              label="Importance"
            >
              <option value="-1">Select</option>
              <option value="1">Very Low</option>
              <option value="2">Low</option>
              <option value="3">Medium</option>
              <option value="4">High</option>
              <option value="5">Highest</option>
            </Field>
            <Field
              name="assignedTo"
              component={this.renderUsersSelect}
              label="Assigned To"
            />
            <Field
              className="form-control"
              name="description"
              component={this.renderField}
              type="text"
              placeholder="Description"
              label="Description"
            />
            <Field
              className="form-control"
              name="escalationActionItems"
              component={this.renderWYSIWYG}
              type="text"
              placeholder="Action Items"
              label="Action Items"
            />
            <Field
              className="form-control"
              name="resolved"
              component={this.renderSelect1}
              type="text"
              label="Resolved"
            >
              <option value="-1">Select</option>
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </Field>
          </fieldset>
        )}

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting || this.props.isExecutive}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.meetingTypeId) {
    errors.meetingTypeId = 'Required';
  }
  if (!values.reps) {
    errors.reps = 'Required';
  }
  if (!values.plan) {
    errors.plan = 'Required';
  }
  if (!values.issueName) {
    errors.issueName = 'Required';
  }
  if (!values.issueTypeId) {
    errors.issueTypeId = 'Required';
  }
  if (!values.importance) {
    errors.importance = 'Required';
  }
  if (!values.assignedTo) {
    errors.assignedTo = 'Required';
  }
  return errors;
};

EventForm = connect(state => ({
  formValues: getFormValues('event')(state),
  initialValues: state.eventmanager.event,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'event' })(EventForm));
export default EventForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/EventForm.js